import { render, staticRenderFns } from "./receivable_choose.vue?vue&type=template&id=c370815c&scoped=true&"
import script from "./receivable_choose.vue?vue&type=script&lang=js&"
export * from "./receivable_choose.vue?vue&type=script&lang=js&"
import style0 from "./receivable_choose.vue?vue&type=style&index=0&id=c370815c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c370815c",
  null
  
)

export default component.exports